import PropTypes from "prop-types";
import React, {Fragment, useEffect, useState, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import ReactApexChart from "react-apexcharts";
import './dashboard.scss'
import Card from "../../components/PurpleTheme/Card";
import CardHeader from "../../components/PurpleTheme/CardHeader";
import SideBar from "components/HorizontalLayout/Sidebar";
import DocsTooltip from "components/Common/DocsTooltip";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  CardBody,
  // CardHeader,
  Col,
  Container,
  Row,
  Table,
  UncontrolledAccordion,
  Toast,
  ToastHeader,
  ToastBody,
  Tooltip,
  Label,
  Input,
  Button,
  Badge,
  Popover,
  PopoverBody,
} from "reactstrap";

import RecentlyAddedResources from "components/RecentlyAddedResources/RecentlyAddedResources";
import AlcomScoreDashboard from "pages/AlcomScoreDashboard/AlcomScoreDashboard";
import AlertAnalytics from "pages/AlertAnalytics/AlertAnalytics";
import AlertList from "pages/AlertLog/AlertList";
import SloDashboard from "pages/SLODashboard/SloDashboard";
import Rca from "pages/Rca/Rca";
import MttrMtta from "pages/MTTR MTTA Dashboard/MttrMtta";


import {
  getCloudResources as onGetCloudResources,
  getNotificationChannels as onGetNotificationChannels,
  getMonitoringSystems as onGetMonitoringSystems,
  getAllMissingAlerts as onGetAllMissingAlerts,
  getAWSChartData as onGetAWSChartData,
  getAlcomScore as onGetAlcomScore,
  // setShowToast as onSetShowToast,
} from "../../store/actions";

import {withTranslation} from "react-i18next";

import {
  getNRDisplayName,
  getStateSpecificAWSLogo,
  getStateSpecificGCPLogo,
  getStateSpecificNRLogo,
  getLogo,
  getStateSpecificDatadogLogo,
  getAppDynamicsLogo,
  getAppDynamicsName,
  getStateSpecificSplunkLogo,
  getSplunkName,
  getStateSpecificAzureLogo,
  getAzureDisplayName,
  getIntegrationURL,
  getDynatraceLogo,
  getDynatraceName, getOciLogo, getOciName, getGrafanaName, getGrafanaLogo, getSignozLogo, getSignozName
} from "../../helpers/component_helpers";

const Dashboard = props => {
  const {all_missing_alerts} = useSelector(state => ({
    all_missing_alerts: state.Dashboard.all_missing_alerts || {
      'Amazon Web Services': {},
      'New Relic': {},
      'Google Cloud Platform': {},
      'Datadog': {},
      'Dynatrace': {},
      'Oracle Cloud Infrastructure': {}
    }
  }));
  const queryParams = new URLSearchParams(location.search);

  const initialTab = ["Dashboard", "AlcomScoreDashboard", "AlertAnalytics", "AlertsList", "SLO", "RCA"].includes(queryParams.get('tab')) ? queryParams.get('tab') : "Dashboard";


  const [tab, setTab] = useState(initialTab);
  const [tright, settright] = useState(false);
  const [systemsTooltip, setSystemsTooltip] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [currentTab, setCurrentTab] = useState(tab || 'Dashboard');
  const [runbookTooltip, setRunbookTooltip] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [currentPopover, setCurrentPopover] = useState(null)

  const navigate = useNavigate();
  const handleTabChange = (newTab) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('tab', newTab);

    navigate({
      pathname: location.pathname,
      search: searchParams.toString()
    }, {replace: true});

    setTab(newTab);
    setCurrentTab(newTab);
  }
  const togglePopover = (popoverId) => {
    if (currentPopover === popoverId) {
      setCurrentPopover(null);
    } else {
      setCurrentPopover(popoverId);
    }
  };

  const toggleTooltip = (index) => {
    setTooltipOpen(!tooltipOpen);
    setCurrentIndex(index);
  };

  const handleMouseOver = (popoverId) => {
    setCurrentPopover(popoverId);
    setTooltipOpen(true);
  };

  const handleMouseOut = () => {
    setTooltipOpen(false);
    setCurrentPopover(null);
    setCurrentIndex(null);
  };
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const currentTabFromURL = searchParams.get('tab');
    if (currentTabFromURL && currentTabFromURL !== tab) {
      setTab(currentTabFromURL);
      setCurrentTab(currentTabFromURL);
    }
  }, [location.search]);


  useEffect(() => {
    const stateOfToast = localStorage.getItem("state_of_toast");
    if (stateOfToast === "true") {
      setShowToast(true);
      hideToastAfterDelay();
    }
  }, []);

  const toggleTab = tab => {
    if (currentTab !== tab) {
      setCurrentTab(tab);
      handleTabChange(tab);
    }
  };

  const closeToast = () => {
    setShowToast(false);
    localStorage.setItem("state_of_toast", "false");
    localStorage.removeItem("state_of_toast");
  };

  const hideToastAfterDelay = () => {
    setTimeout(() => {
      setShowToast(false);
      localStorage.setItem("state_of_toast", "false");
      localStorage.removeItem("state_of_toast");
    }, 5000);
  };


  const {alcom_score} = useSelector(state => ({
    alcom_score: state.Dashboard.alcom_score || {'alcom_score': 0}
  }));

  useEffect(() => {
    dispatch(onGetAlcomScore());
  }, [onGetAlcomScore]);

  const {chart_data} = useSelector(state => ({
    chart_data: state.Dashboard.chart_data || {'dataValues': [], 'dataLabels': []}
  }));

  useEffect(() => {
    dispatch(onGetAWSChartData());
  }, [onGetAWSChartData]);

  const {monitoring_systems} = useSelector(state => ({
    monitoring_systems: state.Dashboard.monitoring_systems,
  }));


  useEffect(() => {
    dispatch(onGetMonitoringSystems());
  }, [onGetMonitoringSystems]);

  const {profile} = useSelector(state => ({
    profile: state.Dashboard.profile
  }));

  useEffect(() => {
    dispatch(onGetCloudResources());
  }, [onGetCloudResources]);

  useEffect(() => {
    dispatch(onGetNotificationChannels());
  }, [onGetNotificationChannels]);

  let {current_notification_channels} = useSelector(state => ({
    current_notification_channels: state.Dashboard.notification_channels || []
  }));

  document.title = "Dashboard";

  const dispatch = useDispatch();

  const headers = ['Resource Name', 'Metric Name', 'Resource Type'];

  let dataLabels = chart_data.dataLabels.map((item, index) => {
    return new Date(item).toString()
  });

  const options = {
    text: {
      fill: {
        color: 'white'
      }
    },
    chart: {
      height: 280,
      type: "radialBar",
    },
    colors: ["#8198FF"],
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        hollow: {
          margin: 0,
          size: "60%",
          background: "none",
        },
        track: {
          startAngle: -135,
          endAngle: 135,
          dropShadow: {
            enabled: true,
            top: 2,
            left: 0,
            blur: 4,
            opacity: 0.15,
          }
        },
        dataLabels: {
          name: {
            offsetY: 45,
            color: "#fff",
            fontSize: "12px"
          },
          value: {
            offsetY: 65,
            color: "#fff",
            fontSize: "28px",
            show: true
          }
        }
      }
    },
    fill: {
      type: "solid",
      colors: ['#3569f3']
    },
    stroke: {
      lineCap: "butt",
      dashArray: 4
    },
    labels: ["ALCOM score"]
  };

  const optionstrend = {
    text: {
      fill: '#ffffff',
    },
    chart: {
      height: 370,
      type: "area",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      lineCap: "round",
      colors: ['#46329F'],
      width: 2,
    },
    fill: {
      colors: ['#3E2C90'],
      opacity: 0.5
    },
    xaxis: {
      type: "datetime",
      floating: false,
      categories: dataLabels,
      labels: {
        show: false,
        style: {
          colors: '#ffffff'
        }
      },
      axisBorder: {
        show: false,
      },
      title: {
        text: "Date",
        style: {
          color: "#ffffff"
        }
      },
      axisTicks: {
        show: false,
        borderType: "dashed",
      },
    },
    yaxis: {
      axisBorder: {
        offsetX: -10,
        width: 2,
      },
      labels: {
        show: true,
        style: {
          colors: '#ffffff' // Color of y-axis labels
        }
      },
      title: {
        text: "Score",
        style: {
          color: "#ffffff" // Color of y-axis title
        }
      },
      axisTicks: {
        show: false,
      },
    },
  };

  function getIntegrations(monitoring_systems) {
    if (monitoring_systems.length > 0) {
      return monitoring_systems.map((item, index) => {
        return (
          <a href={getIntegrationURL(item.name)} key={item.name}>
            <img
              alt={item.name}
              src={getLogo(item.name)}
              className="dashboard-integration-logo float-left"
            />
          </a>
        )
      })
    }
  }

  function getNotificationIntegrations(notification_channels) {
    if (notification_channels.length > 0) {
      return notification_channels.map((item, index) => {
        return (
          <a href={getIntegrationURL(item.name)} key={item.name}>
            <img src={getLogo(item.name)}
                 className="dashboard-integration-logo float-left"/>
          </a>
        )
      })
    }
  }

  useEffect(() => {
    if (currentTab === 'MissingAlerts') {
      dispatch(onGetAllMissingAlerts());
    }
  }, [currentTab]);

  return (
    <React.Fragment>
      {showToast && (
        <div className="position-fixed top-0 end-0 p-3" style={{zIndex: "1005"}}>
          <Toast>
            <ToastHeader toggle={closeToast}>
              Logged in successfully
            </ToastHeader>
            <ToastBody>
              Welcome back to the Temperstack.
            </ToastBody>
          </Toast>
        </div>
      )}
      <div className="d-flex gap-2">
        <div>
          < SideBar
            setCurrentTabFromSidebar={toggleTab}
            current_page={"Dashboard"}
          />
        </div>
        <div style={{width: "100%", marginLeft: '13%'}}>
          <div className="content-page w-100 d-flex justify-content-center">
            <div className="page-content w-100">
              <Container fluid className="content-page">
                {/* Render Breadcrumb */}
                {currentTab === 'Dashboard' || tab === 'Dashboard' ?
                  <div>
                    <Row>
                      <Col xl="3">
                        <Row>
                          <Card height="280px">
                            <CardBody>
                              <h4 className="card-title text-center">Organisation Score
                                <span
                                  id="TooltipRight"
                                  onMouseOver={() => settright(true)}
                                  onMouseLeave={() => settright(false)}
                                  className="alert-icon"
                                ><i className="mdi mdi-information-outline text-white"/>
                            </span>
                                <Tooltip
                                  placement="right"
                                  isOpen={tright}
                                  target="TooltipRight"
                                  toggle={() => {
                                    settright(!tright);
                                  }}
                                  style={{
                                    border: "2px solid white",
                                    borderRadius: "10px",
                                    backgroundColor: "#311946",
                                    zIndex: 1
                                  }}
                                >
                                  Alcom Score is applicable to only production resources
                                </Tooltip>
                              </h4>
                              <ReactApexChart
                                options={options}
                                series={[alcom_score.alcom_score]}
                                type="radialBar"
                                height="250"
                                className="apex-charts"
                              />
                            </CardBody>
                          </Card>
                        </Row>
                        <Row>
                          <Card height="157px">
                            <CardBody className="align-items-center">
                              <div className="d-flex justify-content-center gap-1 align-items-center">
                                <h4 className="font-size-15 mb-0">Systems Integrated</h4>
                                <span role="button" id="systemsTooltip">
                                <i className="bx bx-help-circle font-size-15 mt-1"/>
                              </span>
                              </div>
                              <DocsTooltip
                                placement={'right'}
                                isOpen={systemsTooltip}
                                targetId={'systemsTooltip'}
                                toggle={() => {
                                  setSystemsTooltip(!systemsTooltip);
                                }}
                                multipleLinks={[
                                  {
                                    linkText: "All Integrations",
                                    link: "https://docs.temperstack.com/temperstack/getting-started/integrations-hub"
                                  },
                                  {
                                    linkText: "Integrating Temperstack",
                                    link: "https://docs.temperstack.com/temperstack/overview/integrating-temperstack-as-the-incident-management-tool"
                                  }
                                ]}
                              />
                              <div className="dashboard-integration-logo-display">
                                {getIntegrations(monitoring_systems)}
                                {/*{getNotificationIntegrations(current_notification_channels)}*/}
                              </div>
                            </CardBody>
                          </Card>
                        </Row>
                      </Col>
                      <Col xl="9">
                        <Card className='mb-0' height="453px">
                          <CardBody>
                            <h4 className="card-title text-center">Score Trend</h4>
                            {chart_data['dataValues'].length != 0 ?
                              <ReactApexChart
                                options={optionstrend}
                                series={[{data: chart_data['dataValues']}]}
                                labels={dataLabels}
                                type="area"
                                height="378"
                                className="apex-charts"
                              />
                              :
                              <Card outline color="warning" className="border mt-5 p-5">
                                <CardHeader><h1 className="text-center">Calculating score...</h1></CardHeader>
                                <CardBody>
                                  <p className="text-center">Please wait while we calculate your score.</p>
                                  <h5 className="text-center">Please refresh the page after a few minutes.</h5>
                                </CardBody>
                              </Card>
                            }
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <Row>
                      <Card className="p-4">
                        <RecentlyAddedResources itemsPerPage={3} height="fit-content" maxHeight="360px" monitoringSystems={monitoring_systems}/>
                      </Card>
                    </Row>
                  </div>
                  : null
                }
                {currentTab === 'AlcomScoreDashboard' || tab === 'AlcomScoreDashboard' ? <AlcomScoreDashboard/> : null}
                {currentTab === 'AlertAnalytics' || tab === 'AlertAnalytics' ? <AlertAnalytics/> : null}
                {currentTab === 'SLO' || tab === 'SLO' ? <SloDashboard/> : null}
                {currentTab === 'RCA' || tab === 'RCA' ? <Rca/> : null}
                {/*{currentTab === 'MTTA MTTR' || tab === 'MTTA MTTR' ?<div className="w-100 d-flex justify-content-center"><MttrMtta/></div> : null}*/}
                {currentTab === 'AlertsList' || tab === 'AlertsList' ?
                  <div className="w-100">
                    <div className="d-flex gap-1 align-items-center mb-4">
                      <h5 className="mb-0 text-white">Alerts List</h5>
                      <span role="button" id='runbookTooltip' className="align-items-center" style={{marginTop: "4px"}}>
                          <i className="bx bx-help-circle font-size-15 text-white"/>
                        </span>
                      <DocsTooltip
                        placement={'right'}
                        isOpen={runbookTooltip}
                        targetId={'runbookTooltip'}
                        toggle={() => setRunbookTooltip(!runbookTooltip)}
                        linkText={'Runbooks for alerts'}
                        link={'https://docs.temperstack.com/temperstack/platform/incident-command/ai-powered-contextual-runbooks'}
                      />
                    </div>
                    <Card>
                      <AlertList/>
                    </Card>
                  </div>
                  : null
                }

                {currentTab === 'MissingAlerts' ?
                  <Row>
                    <Card>
                      <Row>
                        <Col lg={12}>

                          <CardBody>
                            <div className="d-sm-flex flex-wrap text-center">
                              <h4 className="card-title mt-2 ms-2 p-2">Missing Alerts</h4>
                            </div>
                          </CardBody>

                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12}>
                          <UncontrolledAccordion defaultOpen={"0"}>
                            {
                              monitoring_systems.map((monitoring_system, index1) => {
                                if (monitoring_system.name === "Amazon Web Services") {
                                  return (
                                    <Fragment key={index1}>
                                      <AccordionItem>
                                        <AccordionHeader targetId={(index1 + 1).toString()}>
                                          <Row className="full-width">
                                            <Col lg="6">
                                              <h5 className="change-table-text">
                                                <img src={getLogo(monitoring_system.name)}
                                                     className="resource-logo"></img>
                                                <span
                                                  className="text-primary">{monitoring_system.name}</span>
                                              </h5>
                                            </Col>
                                          </Row>
                                        </AccordionHeader>
                                        <AccordionBody accordionId={(index1 + 1).toString()}>
                                          <div className="table-responsive react-table">
                                            <Row className="full-width">
                                              <UncontrolledAccordion defaultOpen={"0"}>
                                                {
                                                  Object.keys(all_missing_alerts[monitoring_system.name]).map((resource_type, index2) => {
                                                    return (
                                                      <Fragment key={index2}>
                                                        <AccordionItem>
                                                          <AccordionHeader
                                                            targetId={(index2 + 1).toString()}>
                                                            <Row className="full-width">
                                                              <Col lg="6">
                                                                <h5 className="change-table-text">
                                                                  <img
                                                                    src={getStateSpecificAWSLogo(resource_type)}
                                                                    className="resource-logo"></img>
                                                                  <span
                                                                    className="text-primary">{resource_type}</span>
                                                                </h5>
                                                              </Col>
                                                            </Row>
                                                          </AccordionHeader>
                                                          <AccordionBody
                                                            accordionId={(index2 + 1).toString()}>
                                                            <div
                                                            >
                                                              <Table bordered hover className="table-purple">
                                                                <thead
                                                                  className="table-nowrap table-light">
                                                                <tr>
                                                                  {headers.map((header, index2) => (
                                                                    <th key={index2}>
                                                                      <div
                                                                        className="mb-2 text-white">
                                                                        {header}
                                                                      </div>
                                                                    </th>
                                                                  ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                  all_missing_alerts[monitoring_system.name][resource_type].map((item, index3) => {
                                                                    return (
                                                                      <Fragment
                                                                        key={index3}>
                                                                        {
                                                                          <tr key={index3}>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2">
                                                                                <Link to={`/resource/${item.monitored_resource_id}/alerts`}
                                                                                      className="link-primary">
                                                                                  {item.monitored_resource.name || item.monitored_resource.cloud_reference_id}
                                                                                </Link>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div className="d-inline-flex align-items-center text-white">
                                                                                <div
                                                                                  id={`MetricNamePopover_pop_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`MetricNamePopover_pop_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                >
                                                                                  {item.metric.name}
                                                                                </div>
                                                                                <Popover
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentPopover === `MetricNamePopover_pop_${index1}_${index2}_${index3}`}
                                                                                  target={`MetricNamePopover_pop_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => togglePopover(`MetricNamePopover_pop_${index1}_${index2}_${index3}`)}
                                                                                >
                                                                                  <PopoverBody>{item.metric.name}</PopoverBody>
                                                                                </Popover>
                                                                                <p
                                                                                  id={`Tooltip_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                  className="tooltip-info-icon ms-2 mt-3"
                                                                                >
                                                                                  <i className="bx bx-info-circle font-size-18"></i>
                                                                                </p>
                                                                                <Tooltip
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentIndex === `${index1}_${index2}_${index3}`}
                                                                                  target={`Tooltip_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => toggleTooltip(`${index1}_${index2}_${index3}`)}
                                                                                  style={{
                                                                                    border: "2px solid #f1b44c",
                                                                                    borderRadius: "10px",
                                                                                    backgroundColor: "#2a3042",
                                                                                    zIndex: 1,
                                                                                  }}
                                                                                >
                                                                                  {item.metric.description}
                                                                                </Tooltip>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div className="mb-2 text-white">
                                                                                {item.metric.namespace}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        }
                                                                      </Fragment>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                              </Table>
                                                            </div>
                                                          </AccordionBody>
                                                        </AccordionItem>
                                                      </Fragment>
                                                    )
                                                  })
                                                }
                                              </UncontrolledAccordion>
                                            </Row>
                                          </div>
                                        </AccordionBody>
                                      </AccordionItem>
                                    </Fragment>
                                  )
                                } else if (monitoring_system.name === "New Relic") {
                                  return (
                                    <Fragment key={index1}>
                                      <AccordionItem>
                                        <AccordionHeader targetId={(index1 + 1).toString()}>
                                          <Row className="full-width">
                                            <Col lg="6">
                                              <h5 className="change-table-text">
                                                <img src={getLogo(monitoring_system.name)}
                                                     className="resource-logo"></img>
                                                <span
                                                  className="text-primary">{monitoring_system.name}</span>
                                              </h5>
                                            </Col>
                                          </Row>
                                        </AccordionHeader>
                                        <AccordionBody accordionId={(index1 + 1).toString()}>
                                          <div className="table-responsive react-table">
                                            <Row className="full-width">
                                              <UncontrolledAccordion defaultOpen={"0"}>
                                                {
                                                  Object.keys(all_missing_alerts[monitoring_system.name]).map((resource_type, index2) => {
                                                    return (
                                                      <Fragment key={index2}>
                                                        <AccordionItem>
                                                          <AccordionHeader
                                                            targetId={(index2 + 1).toString()}>
                                                            <Row className="full-width">
                                                              <Col lg="6">
                                                                <h5 className="change-table-text">
                                                                  <img
                                                                    src={getStateSpecificNRLogo(resource_type)}
                                                                    className="resource-logo"></img>
                                                                  <span
                                                                    className="text-primary">{getNRDisplayName(resource_type)}</span>
                                                                </h5>
                                                              </Col>
                                                            </Row>
                                                          </AccordionHeader>
                                                          <AccordionBody
                                                            accordionId={(index2 + 1).toString()}>
                                                            <div
                                                              className="table-responsive react-table">
                                                              <Table bordered hover className="table-purple">
                                                                <thead
                                                                  className="table-light table-nowrap">
                                                                <tr>
                                                                  {headers.map((header, index2) => (
                                                                    <th key={index2}>
                                                                      <div
                                                                        className="mb-2 text-white">
                                                                        {header}
                                                                      </div>
                                                                    </th>
                                                                  ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                  all_missing_alerts[monitoring_system.name][resource_type].map((item, index3) => {
                                                                    return (
                                                                      <Fragment
                                                                        key={index3}>
                                                                        {
                                                                          <tr key={index3}>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2 text-white">
                                                                                <Link to={`/newrelic/resource/${item.monitored_resource_id}/alerts`}
                                                                                      className="link-primary">
                                                                                  {item.monitored_resource.name}
                                                                                </Link>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div className="d-inline-flex align-items-center text-white">
                                                                                <div
                                                                                  id={`MetricNamePopover_pop_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`MetricNamePopover_pop_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                >
                                                                                  {item.new_relic_metric.name}
                                                                                </div>
                                                                                <Popover
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentPopover === `MetricNamePopover_pop_${index1}_${index2}_${index3}`}
                                                                                  target={`MetricNamePopover_pop_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => togglePopover(`MetricNamePopover_pop_${index1}_${index2}_${index3}`)}
                                                                                >
                                                                                  <PopoverBody>{item.new_relic_metric.name}</PopoverBody>
                                                                                </Popover>
                                                                                <p
                                                                                  id={`Tooltip_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                  className="tooltip-info-icon ms-2 mt-3"
                                                                                >
                                                                                  <i className="bx bx-info-circle font-size-18"></i>
                                                                                </p>
                                                                                <Tooltip
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentIndex === `${index1}_${index2}_${index3}`}
                                                                                  target={`Tooltip_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => toggleTooltip(`${index1}_${index2}_${index3}`)}
                                                                                  style={{
                                                                                    border: "2px solid #f1b44c",
                                                                                    borderRadius: "10px",
                                                                                    backgroundColor: "#2a3042",
                                                                                    zIndex: 1,
                                                                                  }}
                                                                                >
                                                                                  {item.new_relic_metric.description}
                                                                                </Tooltip>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2 text-white">
                                                                                {getNRDisplayName(item.monitored_resource.resource_type)}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        }
                                                                      </Fragment>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                              </Table>
                                                            </div>
                                                          </AccordionBody>
                                                        </AccordionItem>
                                                      </Fragment>
                                                    )
                                                  })
                                                }
                                              </UncontrolledAccordion>
                                            </Row>
                                          </div>
                                        </AccordionBody>
                                      </AccordionItem>
                                    </Fragment>
                                  )
                                } else if (monitoring_system.name === "Google Cloud Platform") {
                                  return (
                                    <Fragment key={index1}>
                                      <AccordionItem>
                                        <AccordionHeader targetId={(index1 + 1).toString()}>
                                          <Row className="full-width">
                                            <Col lg="6">
                                              <h5 className="change-table-text">
                                                <img src={getLogo(monitoring_system.name)}
                                                     className="resource-logo"></img>
                                                <span
                                                  className="text-primary">{monitoring_system.name}</span>
                                              </h5>
                                            </Col>
                                          </Row>
                                        </AccordionHeader>
                                        <AccordionBody accordionId={(index1 + 1).toString()}>
                                          <div className="table-responsive react-table">
                                            <Row className="full-width">
                                              <UncontrolledAccordion defaultOpen={"0"}>
                                                {
                                                  Object.keys(all_missing_alerts[monitoring_system.name]).map((resource_type, index2) => {
                                                    return (
                                                      <Fragment key={index2}>
                                                        <AccordionItem>
                                                          <AccordionHeader
                                                            targetId={(index2 + 1).toString()}>
                                                            <Row className="full-width">
                                                              <Col lg="6">
                                                                <h5 className="change-table-text">
                                                                  <img
                                                                    src={getStateSpecificGCPLogo(resource_type)}
                                                                    className="resource-logo"></img>
                                                                  <span className="text-primary">{resource_type}</span>
                                                                </h5>
                                                              </Col>
                                                            </Row>
                                                          </AccordionHeader>
                                                          <AccordionBody
                                                            accordionId={(index2 + 1).toString()}>
                                                            <div
                                                              className="table-responsive react-table">
                                                              <Table bordered hover className="table-purple">
                                                                <thead
                                                                  className="table-light table-nowrap">
                                                                <tr>
                                                                  {headers.map((header, index2) => (
                                                                    <th key={index2}>
                                                                      <div
                                                                        className="mb-2 text-white">
                                                                        {header}
                                                                      </div>
                                                                    </th>
                                                                  ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                  all_missing_alerts[monitoring_system.name][resource_type].map((item, index3) => {
                                                                    return (
                                                                      <Fragment
                                                                        key={index3}>
                                                                        {
                                                                          <tr key={index3}>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2 text-white">
                                                                                <Link to={`/gcp/resource/${item.monitored_resource_id}/alerts`}
                                                                                      className="link-primary">
                                                                                  {item.monitored_resource.name}
                                                                                </Link>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div className="d-inline-flex align-items-center text-white">
                                                                                <div
                                                                                  id={`MetricNamePopover_display_GCP${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`MetricNamePopover_display_GCP${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                >
                                                                                  {item.metric.display_name}
                                                                                </div>
                                                                                <Popover
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentPopover === `MetricNamePopover_display_GCP${index1}_${index2}_${index3}`}
                                                                                  target={`MetricNamePopover_display_GCP${index1}_${index2}_${index3}`}
                                                                                  toggle={() => togglePopover(`MetricNamePopover_display_GCP${index1}_${index2}_${index3}`)}
                                                                                >
                                                                                  <PopoverBody>{item.metric.display_name}</PopoverBody>
                                                                                </Popover>
                                                                                <p
                                                                                  id={`Tooltip_display_GCP${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`Tooltip_display_GCP${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                  className="tooltip-info-icon ms-2 mt-3"
                                                                                >
                                                                                  <i className="bx bx-info-circle font-size-18"></i>
                                                                                </p>
                                                                                <Tooltip
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentIndex === `Tooltip_display_GCP${index1}_${index2}_${index3}`}
                                                                                  target={`Tooltip_display_GCP${index1}_${index2}_${index3}`}
                                                                                  toggle={() => toggleTooltip(`Tooltip_display_GCP${index1}_${index2}_${index3}`)}
                                                                                  style={{
                                                                                    border: "2px solid #f1b44c",
                                                                                    borderRadius: "10px",
                                                                                    backgroundColor: "#2a3042",
                                                                                    zIndex: 1,
                                                                                  }}
                                                                                >
                                                                                  {item.metric.description}
                                                                                </Tooltip>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2 text-white">
                                                                                {resource_type}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        }
                                                                      </Fragment>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                              </Table>
                                                            </div>
                                                          </AccordionBody>
                                                        </AccordionItem>
                                                      </Fragment>
                                                    )
                                                  })
                                                }
                                              </UncontrolledAccordion>
                                            </Row>
                                          </div>
                                        </AccordionBody>
                                      </AccordionItem>
                                    </Fragment>
                                  )
                                } else if (monitoring_system.name === "Oracle Cloud Infrastructure") {
                                  return (
                                    <Fragment key={index1}>
                                      <AccordionItem>
                                        <AccordionHeader targetId={(index1 + 1).toString()}>
                                          <Row className="full-width">
                                            <Col lg="6">
                                              <h5 className="change-table-text">
                                                <img src={getLogo(monitoring_system.name)}
                                                     className="resource-logo"></img>
                                                <span
                                                  className="text-primary">{monitoring_system.name}</span>
                                              </h5>
                                            </Col>
                                          </Row>
                                        </AccordionHeader>
                                        <AccordionBody accordionId={(index1 + 1).toString()}>
                                          <div className="table-responsive react-table">
                                            <Row className="full-width">
                                              <UncontrolledAccordion defaultOpen={"0"}>
                                                {
                                                  Object.keys(all_missing_alerts[monitoring_system.name]).map((resource_type, index2) => {
                                                    return (
                                                      <Fragment key={index2}>
                                                        <AccordionItem>
                                                          <AccordionHeader
                                                            targetId={(index2 + 1).toString()}>
                                                            <Row className="full-width">
                                                              <Col lg="6">
                                                                <h5 className="change-table-text">
                                                                  <img
                                                                    src={getOciLogo(resource_type)}
                                                                    className="resource-logo"></img>
                                                                  <span
                                                                    className="text-primary">{getOciName(resource_type)}</span>
                                                                </h5>
                                                              </Col>
                                                            </Row>
                                                          </AccordionHeader>
                                                          <AccordionBody
                                                            accordionId={(index2 + 1).toString()}>
                                                            <div
                                                              className="table-responsive react-table">
                                                              <Table bordered hover className="table-purple">
                                                                <thead
                                                                  className="table-light table-nowrap">
                                                                <tr>
                                                                  {headers.map((header, index2) => (
                                                                    <th key={index2}>
                                                                      <div
                                                                        className="mb-2 text-white">
                                                                        {header}
                                                                      </div>
                                                                    </th>
                                                                  ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                  all_missing_alerts[monitoring_system.name][resource_type].map((item, index3) => {
                                                                    return (
                                                                      <Fragment
                                                                        key={index3}>
                                                                        {
                                                                          <tr key={index3}>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2">
                                                                                <Link to={`/oci/resource/${item.monitored_resource_id}/alerts`}
                                                                                      className="link-primary">
                                                                                  {item.monitored_resource.name}
                                                                                </Link>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div className="d-inline-flex align-items-center text-white">
                                                                                <div
                                                                                  id={`MetricNamePopover_pop_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`MetricNamePopover_pop_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                >
                                                                                  {item.metric.display_name}
                                                                                </div>
                                                                                <Popover
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentPopover === `MetricNamePopover_pop_${index1}_${index2}_${index3}`}
                                                                                  target={`MetricNamePopover_pop_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => togglePopover(`MetricNamePopover_pop_${index1}_${index2}_${index3}`)}
                                                                                >
                                                                                  <PopoverBody>{item.metric.name}</PopoverBody>
                                                                                </Popover>
                                                                                <p
                                                                                  id={`Tooltip_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                  className="tooltip-info-icon ms-2 mt-3"
                                                                                >
                                                                                  <i className="bx bx-info-circle font-size-18"></i>
                                                                                </p>
                                                                                <Tooltip
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentIndex === `${index1}_${index2}_${index3}`}
                                                                                  target={`Tooltip_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => toggleTooltip(`${index1}_${index2}_${index3}`)}
                                                                                  style={{
                                                                                    border: "2px solid #f1b44c",
                                                                                    borderRadius: "10px",
                                                                                    backgroundColor: "#2a3042",
                                                                                    zIndex: 1,
                                                                                  }}
                                                                                >
                                                                                  {item.metric.description}
                                                                                </Tooltip>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2 text-white">
                                                                                {getOciName(item.monitored_resource.resource_type)}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        }
                                                                      </Fragment>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                              </Table>
                                                            </div>
                                                          </AccordionBody>
                                                        </AccordionItem>
                                                      </Fragment>
                                                    )
                                                  })
                                                }
                                              </UncontrolledAccordion>
                                            </Row>
                                          </div>
                                        </AccordionBody>
                                      </AccordionItem>
                                    </Fragment>
                                  )
                                } else if (monitoring_system.name === "Datadog") {
                                  return (
                                    <Fragment key={index1}>
                                      <AccordionItem>
                                        <AccordionHeader targetId={(index1 + 1).toString()}>
                                          <Row className="full-width">
                                            <Col lg="6">
                                              <h5 className="change-table-text">
                                                <img src={getLogo(monitoring_system.name)}
                                                     className="resource-logo"></img>
                                                <span
                                                  className="text-primary">{monitoring_system.name}</span>
                                              </h5>
                                            </Col>
                                          </Row>
                                        </AccordionHeader>
                                        <AccordionBody accordionId={(index1 + 1).toString()}>
                                          <div className="table-responsive react-table">
                                            <Row className="full-width">
                                              <UncontrolledAccordion defaultOpen={"0"}>
                                                {
                                                  Object.keys(all_missing_alerts[monitoring_system.name]).map((resource_type, index2) => {
                                                    return (
                                                      <Fragment key={index2}>
                                                        <AccordionItem>
                                                          <AccordionHeader
                                                            targetId={(index2 + 1).toString()}>
                                                            <Row className="full-width">
                                                              <Col lg="6">
                                                                <h5 className="change-table-text">
                                                                  <img
                                                                    src={getStateSpecificDatadogLogo(resource_type)}
                                                                    className="resource-logo"></img>
                                                                  <span className="text-primary">{resource_type}</span>
                                                                </h5>
                                                              </Col>
                                                            </Row>
                                                          </AccordionHeader>
                                                          <AccordionBody
                                                            accordionId={(index2 + 1).toString()}>
                                                            <div
                                                              className="table-responsive react-table">
                                                              <Table bordered hover className="table-purple">
                                                                <thead
                                                                  className="table-light table-nowrap">
                                                                <tr>
                                                                  {headers.map((header, index2) => (
                                                                    <th key={index2}>
                                                                      <div
                                                                        className="mb-2 text-white">
                                                                        {header}
                                                                      </div>
                                                                    </th>
                                                                  ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                  all_missing_alerts[monitoring_system.name][resource_type].map((item, index3) => {
                                                                    return (
                                                                      <Fragment
                                                                        key={index3}>
                                                                        {
                                                                          <tr key={index3}>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2">
                                                                                <Link to={`/datadog/resource/${item.monitored_resource_id}/alerts`}
                                                                                      className="link-primary">
                                                                                  {item.monitored_resource.name}
                                                                                </Link>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div className="d-inline-flex align-items-center text-white">
                                                                                <div
                                                                                  id={`MetricNamePopover_datadog_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`MetricNamePopover_datadog_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                >
                                                                                  {item.datadog_metric.name}
                                                                                </div>
                                                                                <Popover
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentPopover === `MetricNamePopover_datadog_${index1}_${index2}_${index3}`}
                                                                                  target={`MetricNamePopover_datadog_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => togglePopover(`MetricNamePopover_datadog_${index1}_${index2}_${index3}`)}
                                                                                >
                                                                                  <PopoverBody>{item.datadog_metric.name}</PopoverBody>
                                                                                </Popover>
                                                                                <p
                                                                                  id={`Tooltip_datadog_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`Tooltip_datadog_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                  className="tooltip-info-icon ms-2 mt-3"
                                                                                >
                                                                                  <i className="bx bx-info-circle font-size-18"></i>
                                                                                </p>
                                                                                <Tooltip
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentIndex === `Tooltip_datadog_${index1}_${index2}_${index3}`}
                                                                                  target={`Tooltip_datadog_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => toggleTooltip(`Tooltip_datadog_${index1}_${index2}_${index3}`)}
                                                                                  style={{
                                                                                    border: "2px solid #f1b44c",
                                                                                    borderRadius: "10px",
                                                                                    backgroundColor: "#2a3042",
                                                                                    zIndex: 1,
                                                                                  }}
                                                                                >
                                                                                  {item.datadog_metric.description}
                                                                                </Tooltip>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2 text-white">
                                                                                {resource_type}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        }
                                                                      </Fragment>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                              </Table>
                                                            </div>
                                                          </AccordionBody>
                                                        </AccordionItem>
                                                      </Fragment>
                                                    )
                                                  })
                                                }
                                              </UncontrolledAccordion>
                                            </Row>
                                          </div>
                                        </AccordionBody>
                                      </AccordionItem>
                                    </Fragment>
                                  )
                                } else if (monitoring_system.name === "Microsoft Azure") {
                                  return (
                                    <Fragment key={index1}>
                                      <AccordionItem>
                                        <AccordionHeader targetId={(index1 + 1).toString()}>
                                          <Row className="full-width">
                                            <Col lg="6">
                                              <h5 className="change-table-text">
                                                <img src={getLogo(monitoring_system.name)}
                                                     className="resource-logo"></img>
                                                <span
                                                  className="text-primary">{monitoring_system.name}</span>
                                              </h5>
                                            </Col>
                                          </Row>
                                        </AccordionHeader>
                                        <AccordionBody accordionId={(index1 + 1).toString()}>
                                          <div className="table-responsive react-table">
                                            <Row className="full-width">
                                              <UncontrolledAccordion defaultOpen={"0"}>
                                                {
                                                  Object.keys(all_missing_alerts[monitoring_system.name]).map((resource_type, index2) => {
                                                    return (
                                                      <Fragment key={index2}>
                                                        <AccordionItem>
                                                          <AccordionHeader
                                                            targetId={(index2 + 1).toString()}>
                                                            <Row className="full-width">
                                                              <Col lg="6">
                                                                <h5 className="change-table-text">
                                                                  <img
                                                                    src={getStateSpecificAzureLogo(resource_type)}
                                                                    className="resource-logo"></img>
                                                                  <span
                                                                    className="text-primary">{getAzureDisplayName(resource_type)}</span>
                                                                </h5>
                                                              </Col>
                                                            </Row>
                                                          </AccordionHeader>
                                                          <AccordionBody
                                                            accordionId={(index2 + 1).toString()}>
                                                            <div
                                                              className="table-responsive react-table">
                                                              <Table bordered hover className="table-purple">
                                                                <thead
                                                                  className="table-light table-nowrap">
                                                                <tr>
                                                                  {headers.map((header, index2) => (
                                                                    <th key={index2}>
                                                                      <div
                                                                        className="mb-2 text-white">
                                                                        {header}
                                                                      </div>
                                                                    </th>
                                                                  ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                  all_missing_alerts[monitoring_system.name][resource_type].map((item, index3) => {
                                                                    return (
                                                                      <Fragment
                                                                        key={index3}>
                                                                        {
                                                                          <tr key={index3}>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2">
                                                                                <Link to={`/azure/resource/${item.monitored_resource_id}/alerts`}
                                                                                      className="link-primary">
                                                                                  {item.monitored_resource.name || item.monitored_resource.cloud_reference_id}
                                                                                </Link>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div className="d-inline-flex align-items-center text-white">
                                                                                <div
                                                                                  id={`MetricNamePopover_display_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`MetricNamePopover_display_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                >
                                                                                  {item.metric.display_name}
                                                                                </div>
                                                                                <Popover
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentPopover === `MetricNamePopover_display_${index1}_${index2}_${index3}`}
                                                                                  target={`MetricNamePopover_display_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => togglePopover(`MetricNamePopover_display_${index1}_${index2}_${index3}`)}
                                                                                >
                                                                                  <PopoverBody>{item.metric.display_name}</PopoverBody>
                                                                                </Popover>
                                                                                <p
                                                                                  id={`Tooltip_display_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`Tooltip_display_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                  className="tooltip-info-icon ms-2 mt-3"
                                                                                >
                                                                                  <i className="bx bx-info-circle font-size-18"></i>
                                                                                </p>
                                                                                <Tooltip
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentIndex === `Tooltip_display_${index1}_${index2}_${index3}`}
                                                                                  target={`Tooltip_display_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => toggleTooltip(`Tooltip_display_${index1}_${index2}_${index3}`)}
                                                                                  style={{
                                                                                    border: "2px solid #f1b44c",
                                                                                    borderRadius: "10px",
                                                                                    backgroundColor: "#2a3042",
                                                                                    zIndex: 1,
                                                                                  }}
                                                                                >
                                                                                  {item.metric.description}
                                                                                </Tooltip>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2 text-white">
                                                                                {getAzureDisplayName(resource_type)}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        }
                                                                      </Fragment>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                              </Table>
                                                            </div>
                                                          </AccordionBody>
                                                        </AccordionItem>
                                                      </Fragment>
                                                    )
                                                  })
                                                }
                                              </UncontrolledAccordion>
                                            </Row>
                                          </div>
                                        </AccordionBody>
                                      </AccordionItem>
                                    </Fragment>
                                  )
                                } else if (monitoring_system.name === "App Dynamics") {
                                  return (
                                    <Fragment key={index1}>
                                      <AccordionItem>
                                        <AccordionHeader targetId={(index1 + 1).toString()}>
                                          <Row className="full-width">
                                            <Col lg="6">
                                              <h5 className="change-table-text">
                                                <img src={getLogo(monitoring_system.name)}
                                                     className="resource-logo"></img>
                                                <span
                                                  className="text-primary">{monitoring_system.name}</span>
                                              </h5>
                                            </Col>
                                          </Row>
                                        </AccordionHeader>
                                        <AccordionBody accordionId={(index1 + 1).toString()}>
                                          <div className="table-responsive react-table">
                                            <Row className="full-width">
                                              <UncontrolledAccordion defaultOpen={"0"}>
                                                {
                                                  Object.keys(all_missing_alerts[monitoring_system.name]).map((resource_type, index2) => {
                                                    return (
                                                      <Fragment key={index2}>
                                                        <AccordionItem>
                                                          <AccordionHeader
                                                            targetId={(index2 + 1).toString()}>
                                                            <Row className="full-width">
                                                              <Col lg="6">
                                                                <h5 className="change-table-text">
                                                                  <img
                                                                    src={getAppDynamicsLogo(resource_type)}
                                                                    className="resource-logo"></img>
                                                                  <span
                                                                    className="text-primary">{getAppDynamicsName(resource_type)}</span>
                                                                </h5>
                                                              </Col>
                                                            </Row>
                                                          </AccordionHeader>
                                                          <AccordionBody
                                                            accordionId={(index2 + 1).toString()}>
                                                            <div
                                                              className="table-responsive react-table">
                                                              <Table bordered hover className="table-purple">
                                                                <thead
                                                                  className="table-light table-nowrap">
                                                                <tr>
                                                                  {headers.map((header, index2) => (
                                                                    <th key={index2}>
                                                                      <div
                                                                        className="mb-2 text-white">
                                                                        {header}
                                                                      </div>
                                                                    </th>
                                                                  ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                  all_missing_alerts[monitoring_system.name][resource_type].map((item, index3) => {
                                                                    return (
                                                                      <Fragment
                                                                        key={index3}>
                                                                        {
                                                                          <tr key={index3}>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2">
                                                                                <Link to={`/appdynamics/resource/${item.monitored_resource_id}/alerts`}
                                                                                      className="link-primary">
                                                                                  {item.monitored_resource.name || item.monitored_resource.cloud_reference_id}
                                                                                </Link>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div className="d-inline-flex align-items-center text-white">
                                                                                <div
                                                                                  id={`MetricNamePopover_appdynamics_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`MetricNamePopover_appdynamics_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                >
                                                                                  {item.appdynamics_metric.name}
                                                                                </div>
                                                                                <Popover
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentPopover === `MetricNamePopover_appdynamics_${index1}_${index2}_${index3}`}
                                                                                  target={`MetricNamePopover_appdynamics_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => togglePopover(`MetricNamePopover_appdynamics_${index1}_${index2}_${index3}`)}
                                                                                >
                                                                                  <PopoverBody>{item.appdynamics_metric.name}</PopoverBody>
                                                                                </Popover>
                                                                                <p
                                                                                  id={`Tooltip_appdynamics_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`Tooltip_appdynamics_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                  className="tooltip-info-icon ms-2 mt-3"
                                                                                >
                                                                                  <i className="bx bx-info-circle font-size-18"></i>
                                                                                </p>
                                                                                <Tooltip
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentIndex === `Tooltip_appdynamics_${index1}_${index2}_${index3}`}
                                                                                  target={`Tooltip_appdynamics_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => toggleTooltip(`Tooltip_appdynamics_${index1}_${index2}_${index3}`)}
                                                                                  style={{
                                                                                    border: "2px solid #f1b44c",
                                                                                    borderRadius: "10px",
                                                                                    backgroundColor: "#2a3042",
                                                                                    zIndex: 1,
                                                                                  }}
                                                                                >
                                                                                  {item.appdynamics_metric.description}
                                                                                </Tooltip>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2 text-white">
                                                                                {getAppDynamicsName(resource_type)}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        }
                                                                      </Fragment>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                              </Table>
                                                            </div>
                                                          </AccordionBody>
                                                        </AccordionItem>
                                                      </Fragment>
                                                    )
                                                  })
                                                }
                                              </UncontrolledAccordion>
                                            </Row>
                                          </div>
                                        </AccordionBody>
                                      </AccordionItem>
                                    </Fragment>
                                  )
                                } else if (monitoring_system.name === "Splunk") {
                                  return (
                                    <Fragment key={index1}>
                                      <AccordionItem>
                                        <AccordionHeader targetId={(index1 + 1).toString()}>
                                          <Row className="full-width">
                                            <Col lg="6">
                                              <h5 className="change-table-text">
                                                <img src={getLogo(monitoring_system.name)}
                                                     className="resource-logo"></img>
                                                <span
                                                  className="text-primary">{monitoring_system.name}</span>
                                              </h5>
                                            </Col>
                                          </Row>
                                        </AccordionHeader>
                                        <AccordionBody accordionId={(index1 + 1).toString()}>
                                          <div className="table-responsive react-table">
                                            <Row className="full-width">
                                              <UncontrolledAccordion defaultOpen={"0"}>
                                                {
                                                  Object.keys(all_missing_alerts[monitoring_system.name]).map((resource_type, index2) => {
                                                    return (
                                                      <Fragment key={index2}>
                                                        <AccordionItem>
                                                          <AccordionHeader
                                                            targetId={(index2 + 1).toString()}>
                                                            <Row className="full-width">
                                                              <Col lg="6">
                                                                <h5 className="change-table-text">
                                                                  <img
                                                                    src={getStateSpecificSplunkLogo(resource_type)}
                                                                    className="resource-logo"></img>
                                                                  <span
                                                                    className="text-primary">{getSplunkName(resource_type)}</span>
                                                                </h5>
                                                              </Col>
                                                            </Row>
                                                          </AccordionHeader>
                                                          <AccordionBody
                                                            accordionId={(index2 + 1).toString()}>
                                                            <div
                                                              className="table-responsive react-table">
                                                              <Table bordered hover className="table-purple">
                                                                <thead
                                                                  className="table-light table-nowrap">
                                                                <tr>
                                                                  {headers.map((header, index2) => (
                                                                    <th key={index2}>
                                                                      <div
                                                                        className="mb-2 text-white">
                                                                        {header}
                                                                      </div>
                                                                    </th>
                                                                  ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                  all_missing_alerts[monitoring_system.name][resource_type].map((item, index3) => {
                                                                    return (
                                                                      <Fragment
                                                                        key={index3}>
                                                                        {
                                                                          <tr key={index3}>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2">
                                                                                <Link to={`/splunk/resource/${item.monitored_resource_id}/alerts`}
                                                                                      className="link-primary">
                                                                                  {item.monitored_resource.name || item.monitored_resource.cloud_reference_id}
                                                                                </Link>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div className="d-inline-flex align-items-center text-white">
                                                                                <div
                                                                                  id={`MetricNamePopover_splunk_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`MetricNamePopover_splunk_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                >
                                                                                  {item.splunk_metric.name}
                                                                                </div>
                                                                                <Popover
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentPopover === `MetricNamePopover_splunk_${index1}_${index2}_${index3}`}
                                                                                  target={`MetricNamePopover_splunk_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => togglePopover(`MetricNamePopover_splunk_${index1}_${index2}_${index3}`)}
                                                                                >
                                                                                  <PopoverBody>{item.splunk_metric.name}</PopoverBody>
                                                                                </Popover>
                                                                                <p
                                                                                  id={`Tooltip_splunk_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`Tooltip_splunk_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                  className="tooltip-info-icon ms-2 mt-3"
                                                                                >
                                                                                  <i className="bx bx-info-circle font-size-18"></i>
                                                                                </p>
                                                                                <Tooltip
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentIndex === `Tooltip_splunk_${index1}_${index2}_${index3}`}
                                                                                  target={`Tooltip_splunk_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => toggleTooltip(`Tooltip_splunk_${index1}_${index2}_${index3}`)}
                                                                                  style={{
                                                                                    border: "2px solid #f1b44c",
                                                                                    borderRadius: "10px",
                                                                                    backgroundColor: "#2a3042",
                                                                                    zIndex: 1,
                                                                                  }}
                                                                                >
                                                                                  {item.splunk_metric.description}
                                                                                </Tooltip>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2 text-white">
                                                                                {getSplunkName(resource_type)}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        }
                                                                      </Fragment>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                              </Table>
                                                            </div>
                                                          </AccordionBody>
                                                        </AccordionItem>
                                                      </Fragment>
                                                    )
                                                  })
                                                }
                                              </UncontrolledAccordion>
                                            </Row>
                                          </div>
                                        </AccordionBody>
                                      </AccordionItem>
                                    </Fragment>
                                  )
                                } else if (monitoring_system.name === "Dynatrace") {
                                  return (
                                    <Fragment key={index1}>
                                      <AccordionItem>
                                        <AccordionHeader targetId={(index1 + 1).toString()}>
                                          <Row className="full-width">
                                            <Col lg="6">
                                              <h5 className="change-table-text">
                                                <img src={getLogo(monitoring_system.name)}
                                                     className="resource-logo"></img>
                                                <span
                                                  className="text-primary">{monitoring_system.name}</span>
                                              </h5>
                                            </Col>
                                          </Row>
                                        </AccordionHeader>
                                        <AccordionBody accordionId={(index1 + 1).toString()}>
                                          <div className="table-responsive react-table">
                                            <Row className="full-width">
                                              <UncontrolledAccordion defaultOpen={"0"}>
                                                {
                                                  Object.keys(all_missing_alerts[monitoring_system.name]).map((resource_type, index2) => {
                                                    return (
                                                      <Fragment key={index2}>
                                                        <AccordionItem>
                                                          <AccordionHeader
                                                            targetId={(index2 + 1).toString()}>
                                                            <Row className="full-width">
                                                              <Col lg="6">
                                                                <h5 className="change-table-text">
                                                                  <img
                                                                    src={getDynatraceLogo(resource_type)}
                                                                    className="resource-logo"></img>
                                                                  <span
                                                                    className="text-primary">{getDynatraceName(resource_type)}</span>
                                                                </h5>
                                                              </Col>
                                                            </Row>
                                                          </AccordionHeader>
                                                          <AccordionBody accordionId={(index2 + 1).toString()}>
                                                            <div className="table-responsive react-table">
                                                              <Table bordered hover className="table-purple">
                                                                <thead
                                                                  className="table-light table-nowrap">
                                                                <tr>
                                                                  {headers.map((header, index2) => (
                                                                    <th key={index2}>
                                                                      <div
                                                                        className="mb-2 text-white">
                                                                        {header}
                                                                      </div>
                                                                    </th>
                                                                  ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                  all_missing_alerts[monitoring_system.name][resource_type].map((item, index3) => {
                                                                    return (
                                                                      <Fragment
                                                                        key={index3}>
                                                                        {
                                                                          <tr key={index3}>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2">
                                                                                <Link to={`/dynatrace/resource/${item.monitored_resource_id}/alerts`}
                                                                                      className="link-primary">
                                                                                  {item.monitored_resource.name || item.monitored_resource.cloud_reference_id}
                                                                                </Link>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div className="d-inline-flex align-items-center text-white">
                                                                                <div
                                                                                  id={`MetricNamePopover_dynatrace_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`MetricNamePopover_dynatrace_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                  className="text-white"
                                                                                >
                                                                                  {item.dynatrace_metric.name}
                                                                                </div>
                                                                                <Popover
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentPopover === `MetricNamePopover_dynatrace_${index1}_${index2}_${index3}`}
                                                                                  target={`MetricNamePopover_dynatrace_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => togglePopover(`MetricNamePopover_dynatrace_${index1}_${index2}_${index3}`)}
                                                                                >
                                                                                  <PopoverBody>{item.dynatrace_metric.name}</PopoverBody>
                                                                                </Popover>
                                                                                <p
                                                                                  id={`Tooltip_dynatrace_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`Tooltip_dynatrace_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                  className="tooltip-info-icon ms-2 mt-3"
                                                                                >
                                                                                  <i className="bx bx-info-circle font-size-18"></i>
                                                                                </p>
                                                                                <Tooltip
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentIndex === `Tooltip_dynatrace_${index1}_${index2}_${index3}`}
                                                                                  target={`Tooltip_dynatrace_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => toggleTooltip(`Tooltip_dynatrace_${index1}_${index2}_${index3}`)}
                                                                                  style={{
                                                                                    border: "2px solid #f1b44c",
                                                                                    borderRadius: "10px",
                                                                                    backgroundColor: "#2a3042",
                                                                                    zIndex: 1,
                                                                                  }}
                                                                                >
                                                                                  {item.dynatrace_metric.description}
                                                                                </Tooltip>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2 text-white">
                                                                                {getDynatraceName(resource_type)}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        }
                                                                      </Fragment>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                              </Table>
                                                            </div>
                                                          </AccordionBody>
                                                        </AccordionItem>
                                                      </Fragment>
                                                    )
                                                  })
                                                }
                                              </UncontrolledAccordion>
                                            </Row>
                                          </div>
                                        </AccordionBody>
                                      </AccordionItem>
                                    </Fragment>
                                  )
                                } else if (monitoring_system.name === "Grafana") {
                                  return (
                                    <Fragment key={index1}>
                                      <AccordionItem>
                                        <AccordionHeader targetId={(index1 + 1).toString()}>
                                          <Row className="full-width">
                                            <Col lg="6">
                                              <h5 className="change-table-text">
                                                <img src={getLogo(monitoring_system.name)}
                                                     className="resource-logo"></img>
                                                <span
                                                  className="text-primary">{monitoring_system.name}</span>
                                              </h5>
                                            </Col>
                                          </Row>
                                        </AccordionHeader>
                                        <AccordionBody accordionId={(index1 + 1).toString()}>
                                          <div className="table-responsive react-table">
                                            <Row className="full-width">
                                              <UncontrolledAccordion defaultOpen={"0"}>
                                                {
                                                  Object.keys(all_missing_alerts[monitoring_system.name]).map((resource_type, index2) => {
                                                    return (
                                                      <Fragment key={index2}>
                                                        <AccordionItem>
                                                          <AccordionHeader
                                                            targetId={(index2 + 1).toString()}>
                                                            <Row className="full-width">
                                                              <Col lg="6">
                                                                <h5 className="change-table-text">
                                                                  <img
                                                                    src={getGrafanaLogo(resource_type)}
                                                                    className="resource-logo"></img>
                                                                  <span
                                                                    className="text-primary">{getGrafanaName(resource_type)}</span>
                                                                </h5>
                                                              </Col>
                                                            </Row>
                                                          </AccordionHeader>
                                                          <AccordionBody accordionId={(index2 + 1).toString()}>
                                                            <div className="table-responsive react-table">
                                                              <Table bordered hover className="table-purple">
                                                                <thead
                                                                  className="table-light table-nowrap">
                                                                <tr>
                                                                  {headers.map((header, index2) => (
                                                                    <th key={index2}>
                                                                      <div
                                                                        className="mb-2 text-white">
                                                                        {header}
                                                                      </div>
                                                                    </th>
                                                                  ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                  all_missing_alerts[monitoring_system.name][resource_type].map((item, index3) => {
                                                                    return (
                                                                      <Fragment
                                                                        key={index3}>
                                                                        {
                                                                          <tr key={index3}>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2">
                                                                                <Link to={`/grafana/resource/${item.monitored_resource_id}/alerts`}
                                                                                      className="link-primary">
                                                                                  {item.monitored_resource.name || item.monitored_resource.cloud_reference_id}
                                                                                </Link>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div className="d-inline-flex align-items-center text-white">
                                                                                <div
                                                                                  id={`MetricNamePopover_grafana_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`MetricNamePopover_grafana_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                >
                                                                                  {item.grafana_metric.name}
                                                                                </div>
                                                                                <Popover
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentPopover === `MetricNamePopover_grafana_${index1}_${index2}_${index3}`}
                                                                                  target={`MetricNamePopover_grafana_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => togglePopover(`MetricNamePopover_grafana_${index1}_${index2}_${index3}`)}
                                                                                >
                                                                                  <PopoverBody>{item.grafana_metric.name}</PopoverBody>
                                                                                </Popover>
                                                                                <p
                                                                                  id={`Tooltip_grafana_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`Tooltip_grafana_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                  className="tooltip-info-icon ms-2 mt-3"
                                                                                >
                                                                                  <i className="bx bx-info-circle font-size-18"></i>
                                                                                </p>
                                                                                <Tooltip
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentIndex === `Tooltip_grafana_${index1}_${index2}_${index3}`}
                                                                                  target={`Tooltip_grafana_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => toggleTooltip(`Tooltip_grafana_${index1}_${index2}_${index3}`)}
                                                                                  style={{
                                                                                    border: "2px solid #f1b44c",
                                                                                    borderRadius: "10px",
                                                                                    backgroundColor: "#2a3042",
                                                                                    zIndex: 1,
                                                                                  }}
                                                                                >
                                                                                  {item.grafana_metric.description}
                                                                                </Tooltip>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2 text-white">
                                                                                {getGrafanaName(resource_type)}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        }
                                                                      </Fragment>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                              </Table>
                                                            </div>
                                                          </AccordionBody>
                                                        </AccordionItem>
                                                      </Fragment>
                                                    )
                                                  })
                                                }
                                              </UncontrolledAccordion>
                                            </Row>
                                          </div>
                                        </AccordionBody>
                                      </AccordionItem>
                                    </Fragment>
                                  )
                                }
                                else if (monitoring_system.name === "Signoz") {
                                  return (
                                    <Fragment key={index1}>
                                      <AccordionItem>
                                        <AccordionHeader targetId={(index1 + 1).toString()}>
                                          <Row className="full-width">
                                            <Col lg="6">
                                              <h5 className="change-table-text">
                                                <img src={getLogo(monitoring_system.name)}
                                                     className="resource-logo"></img>
                                                <span
                                                  className="text-primary">{monitoring_system.name}</span>
                                              </h5>
                                            </Col>
                                          </Row>
                                        </AccordionHeader>
                                        <AccordionBody accordionId={(index1 + 1).toString()}>
                                          <div className="table-responsive react-table">
                                            <Row className="full-width">
                                              <UncontrolledAccordion defaultOpen={"0"}>
                                                {
                                                  (all_missing_alerts[monitoring_system.name]
                                                      ? Object.keys(all_missing_alerts[monitoring_system.name])
                                                      : []
                                                  ).map((resource_type, index2) => {
                                                    return (
                                                      <Fragment key={index2}>
                                                        <AccordionItem>
                                                          <AccordionHeader
                                                            targetId={(index2 + 1).toString()}>
                                                            <Row className="full-width">
                                                              <Col lg="6">
                                                                <h5 className="change-table-text">
                                                                  <img
                                                                    src={getSignozLogo(resource_type)}
                                                                    className="resource-logo"></img>
                                                                  <span
                                                                    className="text-primary">{getSignozName(resource_type)}</span>
                                                                </h5>
                                                              </Col>
                                                            </Row>
                                                          </AccordionHeader>
                                                          <AccordionBody accordionId={(index2 + 1).toString()}>
                                                            <div className="table-responsive react-table">
                                                              <Table bordered hover className="table-purple">
                                                                <thead
                                                                  className="table-light table-nowrap">
                                                                <tr>
                                                                  {headers.map((header, index2) => (
                                                                    <th key={index2}>
                                                                      <div
                                                                        className="mb-2 text-white">
                                                                        {header}
                                                                      </div>
                                                                    </th>
                                                                  ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                  all_missing_alerts[monitoring_system.name][resource_type].map((item, index3) => {
                                                                    return (
                                                                      <Fragment
                                                                        key={index3}>
                                                                        {
                                                                          <tr key={index3}>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2">
                                                                                <Link to={`/signoz/resource/${item.monitored_resource_id}/alerts`}
                                                                                      className="link-primary">
                                                                                  {item?.monitored_resource?.name || item?.monitored_resource?.cloud_reference_id}
                                                                                </Link>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div className="d-inline-flex align-items-center text-white">
                                                                                <div
                                                                                  id={`MetricNamePopover_signoz_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`MetricNamePopover_signoz_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                >
                                                                                  {item?.signoz_metric?.name}
                                                                                </div>
                                                                                <Popover
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentPopover === `MetricNamePopover_signoz_${index1}_${index2}_${index3}`}
                                                                                  target={`MetricNamePopover_signoz_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => togglePopover(`MetricNamePopover_signoz_${index1}_${index2}_${index3}`)}
                                                                                >
                                                                                  <PopoverBody>{item?.signoz_metric?.name}</PopoverBody>
                                                                                </Popover>
                                                                                <p
                                                                                  id={`Tooltip_signoz_${index1}_${index2}_${index3}`}
                                                                                  onMouseOver={() => handleMouseOver(`Tooltip_signoz_${index1}_${index2}_${index3}`)}
                                                                                  onMouseLeave={handleMouseOut}
                                                                                  className="tooltip-info-icon ms-2 mt-3"
                                                                                >
                                                                                  <i className="bx bx-info-circle font-size-18"></i>
                                                                                </p>
                                                                                <Tooltip
                                                                                  placement="top"
                                                                                  isOpen={tooltipOpen && currentIndex === `Tooltip_signoz_${index1}_${index2}_${index3}`}
                                                                                  target={`Tooltip_signoz_${index1}_${index2}_${index3}`}
                                                                                  toggle={() => toggleTooltip(`Tooltip_signoz_${index1}_${index2}_${index3}`)}
                                                                                  style={{
                                                                                    border: "2px solid #f1b44c",
                                                                                    borderRadius: "10px",
                                                                                    backgroundColor: "#2a3042",
                                                                                    zIndex: 1,
                                                                                  }}
                                                                                >
                                                                                  {item?.signoz_metric?.description}
                                                                                </Tooltip>
                                                                              </div>
                                                                            </td>
                                                                            <td>
                                                                              <div
                                                                                className="mb-2 text-white">
                                                                                {getSignozName(resource_type)}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        }
                                                                      </Fragment>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                              </Table>
                                                            </div>
                                                          </AccordionBody>
                                                        </AccordionItem>
                                                      </Fragment>
                                                    )
                                                  })
                                                }
                                              </UncontrolledAccordion>
                                            </Row>
                                          </div>
                                        </AccordionBody>
                                      </AccordionItem>
                                    </Fragment>
                                  )
                                }
                              })
                            }
                          </UncontrolledAccordion>
                        </Col>
                      </Row>
                    </Card>
                  </Row> : null
                }

              </Container>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Dashboard);
